import './radioGroup.scss';

import { ReactNode } from 'react';

import { Radio } from '../Radio/Radio';
import { RadioGroupProps } from './types/RadioGroupProps';

export const RadioGroup = ({
  name,
  options,
  register,
  watch,
  defaultValue = '',
  labelPlacement = 'beside',
  variant = 'stacked',
  testId,
  onClick,
}: RadioGroupProps): ReactNode => {
  const selectedValue = watch(name, defaultValue);

  return (
    <div
      className={`radio-group ${variant}`}
      data-testid={testId}
      role="radiogroup"
    >
      {options
        .filter((option): boolean => option.condition !== false)
        .map(
          (option): ReactNode => (
            <Radio
              {...register(name)}
              checked={selectedValue === option.value}
              data-testid={option.testId}
              key={option.value}
              label={option.label}
              labelPlacement={labelPlacement}
              value={option.value}
              onClick={onClick}
            />
          ),
        )}
    </div>
  );
};
